var _rect, _circle, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _circle2, _g30, _text, _g31, _g32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#B1D9A3",
    width: 178.6,
    height: 260.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 146.4,
    cy: 210.3,
    r: 2.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-1 0 0 -1 150.5132 219.7319)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "1"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#59A260",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M72.2,154.9c0,0-62.8-78,20.3-151.2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBD7B",
    d: "M23.5,44.7c4-6.9,6.5-14.9,6.9-23.5s-1.2-16.7-4.5-24c-4,6.9-6.5,14.9-6.9,23.5S20.3,37.4,23.5,44.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#72A179",
    points: "23.9,37.5 25.7,-7.2 26.5,-7.1  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E37149",
    cx: 164.1,
    cy: 40,
    r: 8.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 161.9,
    cy: 41.1,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 166.7,
    cy: 34.9,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 165.2,
    cy: 46.8,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 161.1,
    cy: 45.6,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 164.3,
    cy: 44.1,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 162.4,
    cy: 35.5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 158.4,
    cy: 41.9,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 158.6,
    cy: 37.2,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 167.3,
    cy: 46,
    r: 0.1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E37149",
    cx: 104.1,
    cy: 24.2,
    r: 5.6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 102.6,
    cy: 24.9,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 105.8,
    cy: 20.7,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 104.8,
    cy: 28.7,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 102.1,
    cy: 27.9,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 104.2,
    cy: 26.9,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 106.4,
    cy: 23.1,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 102.9,
    cy: 21.2,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 100.3,
    cy: 25.5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 100.4,
    cy: 22.3,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 106.4,
    cy: 25.5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 107.5,
    cy: 21.3,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 108.5,
    cy: 25.1,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 106.2,
    cy: 28.2,
    r: 0.1
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E37149",
    cx: 77.3,
    cy: 3.3,
    r: 7.6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 75.3,
    cy: 4.3,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 78.4,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 74.6,
    cy: 8.4,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 77.5,
    cy: 7,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 80.5,
    cy: 1.9,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 72.2,
    cy: 5.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 72.4,
    cy: 0.7,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 80.6,
    cy: 5.1,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 83.4,
    cy: 4.6,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 80.3,
    cy: 8.8,
    r: 0.1
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBD7B",
    d: "M127,24c4.5,7,11.9,10.9,19.6,11.2c2.9-7.1,2.4-15.5-2.1-22.5c-4.5-7-11.9-10.9-19.6-11.2 C122,8.6,122.5,17,127,24z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#72A179",
    points: "139.5,24.2 120.2,-4.8 121,-5.4  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBD7B",
    d: "M71.2,40.1c1.4,5.8,5.5,10.2,10.6,12.2c3.7-4.1,5.3-9.9,3.9-15.7c-1.4-5.8-5.5-10.2-10.6-12.2 C71.5,28.6,69.8,34.4,71.2,40.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#72A179",
    points: "79.6,43.3 73.4,19 74.1,18.9  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M81.5,17.2c-2.9,7.8-1.6,16.1,2.8,22.4c7.4-1.9,13.9-7.4,16.7-15.1S102.6,8.4,98.2,2 C90.8,4,84.4,9.4,81.5,17.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "88.8,27.4 100.4,-5.6 101.4,-5.2  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M106.5,11.9c2.8,6.5,8.6,10.8,15,12.1c3.4-5.6,4.2-12.8,1.3-19.3c-2.8-6.5-8.6-10.8-15-12.1 C104.4-1.7,103.7,5.4,106.5,11.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "117.1,13.8 104.7,-13.4 105.4,-13.7  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M106.9,34.4c-1.1,3.6-0.4,7.3,1.7,10.1c3.3-1,6.1-3.6,7.3-7.2c1.1-3.6,0.4-7.3-1.7-10.1 C110.8,28.2,108,30.8,106.9,34.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "110.4,38.8 115,23.7 115.4,23.8  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M137.2,4c-3.1,9.8-1,19.9,4.8,27.5c9.1-2.8,16.7-9.9,19.8-19.7c3.1-9.8,1-19.9-4.8-27.5 C147.9-12.9,140.3-5.8,137.2,4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "146.8,16.1 159.3,-25.3 160.4,-24.9  "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M73,20.8c2.6,6.1,7.9,10.2,13.9,11.4c3.2-5.2,4-11.9,1.4-17.9C85.7,8.2,80.4,4.2,74.4,2.9 C71.2,8.1,70.4,14.8,73,20.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "82.8,22.7 71.5,-2.7 72.2,-3  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M34.1,15.9c0.5,6.4,4.2,11.8,9.4,14.8c4.6-3.8,7.3-9.8,6.7-16.2C49.7,8.1,46,2.8,40.8-0.3 C36.2,3.6,33.5,9.5,34.1,15.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "42.6,20.7 39.8,-6.3 40.6,-6.4  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M9.1,7.9c-2.5,4.3-2.5,9.4-0.5,13.6c4.6-0.4,9-3,11.5-7.4s2.5-9.4,0.5-13.6C15.9,1,11.6,3.6,9.1,7.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "12.5,14.7 22.6,-3.8 23.1,-3.5  "
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M8.4,45c4.1,4.7,10.1,6.7,15.8,6.1c1.3-5.6,0-11.8-4.1-16.4s-10.1-6.7-15.8-6.1C3,34.2,4.3,40.3,8.4,45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "17.8,43.8 0.1,24.4 0.6,23.9  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBD7B",
    d: "M27.3,42.4c9.4-4.1,18.1-10.4,25.1-18.8S64,5.4,66.2-4.6C56.8-0.6,48.1,5.7,41.1,14.2S29.5,32.3,27.3,42.4z "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#72A179",
    points: "33.3,35.3 69.3,-9.3 70.1,-8.7  "
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBD7B",
    d: "M117.1,33.3c0.3-7.7-1.1-15.6-4.5-23.1C109.1,2.8,104.1-3.5,98-8.2c-0.3,7.7,1.1,15.6,4.5,23.1 S111,28.5,117.1,33.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#72A179",
    points: "114.2,27 95.9,-11.9 96.6,-12.2  "
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBD7B",
    d: "M153.9,46.4c5.8-6.5,10.3-14.4,12.6-23.5s2.4-18.1,0.6-26.7c-5.8,6.5-10.3,14.4-12.6,23.5 S152,37.9,153.9,46.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#72A179",
    points: "155.9,38.8 167.8,-8.4 168.7,-8.2  "
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#59A260",
    d: "M100,60.4c8.6-6.4,15.8-14.8,20.9-25.1c5-10.2,7.3-21.1,7.1-31.8c-8.6,6.4-15.8,14.8-20.9,25.1 C102.1,38.8,99.8,49.7,100,60.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#547056",
    points: "104.3,51.8 130,-2 131,-1.5  "
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#59A260",
    d: "M95,48.5c3.2-9.4,4.4-19.6,2.9-30.1s-5.4-20-11.1-28.1c-3.2,9.4-4.4,19.6-2.9,30.1S89.3,40.4,95,48.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D8552",
    points: "93.8,39.6 85.4,-14.9 86.4,-15.1  "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M42.8,27.5C45,37.7,52,45.7,61,49.5c6.6-7.1,9.7-17.2,7.6-27.4S59.3,3.9,50.4,0.1 C43.8,7.2,40.7,17.3,42.8,27.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4B5551",
    points: "57.5,33.4 47.6,-9.5 48.8,-9.7  "
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBD7B",
    d: "M-7.4,29.7c7.1-3,13.6-7.8,18.8-14.1S20,2,21.7-5.6C14.6-2.5,8.1,2.2,2.9,8.5S-5.8,22.1-7.4,29.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#72A179",
    points: "-3,24.3 24,-9.1 24.6,-8.6  "
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#59A260",
    d: "M31.3,24.9c0.7-5.6,0.1-11.5-2-17.1S23.8-2.7,19.6-6.5c-0.7,5.6-0.1,11.5,2,17.1S27.1,21.1,31.3,24.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#547056",
    points: "29.5,20.1 18.3,-9.3 18.8,-9.5  "
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E37149",
    cx: 72,
    cy: 26.5,
    r: 9.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 69.6,
    cy: 27.7,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 74.8,
    cy: 20.9,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 73.2,
    cy: 33.9,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 68.7,
    cy: 32.6,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 72.2,
    cy: 31,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 75.7,
    cy: 24.8,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 70.1,
    cy: 21.6,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 65.8,
    cy: 28.6,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 66,
    cy: 23.4,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 75.9,
    cy: 28.6,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 77.6,
    cy: 21.9,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 79.2,
    cy: 28.1,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 75.5,
    cy: 33.1,
    r: 0.1
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E37149",
    cx: 34.5,
    cy: 1.2,
    r: 7.6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 32.5,
    cy: 2.2,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 35.5,
    cy: 7.4,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 31.7,
    cy: 6.4,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 34.6,
    cy: 5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 29.3,
    cy: 3,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 37.7,
    cy: 3,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 40.5,
    cy: 2.5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 37.4,
    cy: 6.7,
    r: 0.1
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E37149",
    cx: 6.5,
    cy: 43.6,
    r: 7.6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 4.5,
    cy: 44.6,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 8.9,
    cy: 39,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 7.5,
    cy: 49.8,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 3.7,
    cy: 48.7,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 6.6,
    cy: 47.4,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 9.6,
    cy: 42.2,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 4.9,
    cy: 39.6,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 1.3,
    cy: 45.4,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 1.5,
    cy: 41.1,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 9.7,
    cy: 45.4,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 11.1,
    cy: 39.7,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 12.5,
    cy: 44.9,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 9.4,
    cy: 49.1,
    r: 0.1
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E37149",
    cx: 131.6,
    cy: 2.7,
    r: 10.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 128.9,
    cy: 4.1,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 133,
    cy: 11.2,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 127.9,
    cy: 9.7,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 131.8,
    cy: 7.8,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 135.9,
    cy: 0.8,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 124.6,
    cy: 5.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 136,
    cy: 5.1,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 139.8,
    cy: 4.5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 135.6,
    cy: 10.2,
    r: 0.1
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBD7B",
    d: "M67.2,30.2c3-5.3,4.9-11.3,5.2-17.8S71.5-0.3,69-5.8C66-0.6,64.1,5.5,63.7,12S64.7,24.7,67.2,30.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#72A179",
    points: "67.5,24.7 68.8,-9.2 69.4,-9.1  "
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E37149",
    cx: 86.9,
    cy: 194.1,
    r: 35.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 80.3,
    cy: 202.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 88.3,
    cy: 169.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 103,
    cy: 218.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 85,
    cy: 221,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 94.8,
    cy: 209.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 97.6,
    cy: 182.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 72.5,
    cy: 179.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 68.3,
    cy: 211.3,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 60.8,
    cy: 192.6,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 104.2,
    cy: 195.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 99.5,
    cy: 168.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 115.2,
    cy: 188.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BE5338",
    cx: 110,
    cy: 211.9,
    r: 0.5
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 20.8,
    cy: 39.2,
    r: 2.6
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 16.7172 29.7173)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "1"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.5473 180.6374)",
    fontFamily: "'RobotoSlab-Thin'",
    fontSize: 160
  }, "1")), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M75.6,167.9c8.1-0.8,16-4.1,22.4-10c6.4-5.9,10.3-13.5,11.8-21.5c-8.1,0.8-16,4.1-22.4,10 C80.9,152.3,77,159.9,75.6,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M34.3,151.4c4.4,6.8,10.9,12.4,19.1,15.4s16.8,3.1,24.5,0.7c-4.4-6.8-10.9-12.4-19.1-15.4 C50.6,149.1,42.1,149.1,34.3,151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M69.4,134.5c-2.3,5.2-3.1,11.3-1.7,17.3c1.4,6,4.7,11.1,9.1,14.8c2.3-5.2,3.1-11.3,1.7-17.3 C77.1,143.2,73.8,138.1,69.4,134.5z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -258.3,
    y: -5.7,
    width: 178.6,
    height: 260.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M13.7,58.3c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3c-0.8-0.8-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1 c-0.1,0.3,0,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7 l0.9-0.9C13.3,58.5,13.6,58.5,13.7,58.3z M11.2,58.9L10.3,58c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9 c0,0.1,0,0.3,0,0.4l-0.9,0.9C11.4,58.9,11.3,58.9,11.2,58.9z M8.4,55.7l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4 l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1C8.4,56,8.4,55.8,8.4,55.7z M13.4,51l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0 l-0.9-1c0-0.1,0-0.3,0-0.4L13,51C13.2,51.1,13.3,51.1,13.4,51z M16.2,53.8c0,0.1,0,0.3,0,0.4l-0.9,0.9c-0.1,0-0.3,0-0.4,0 L14,54.2c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L16.2,53.8z M13,57l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0 l0.9,0.9c0,0.1,0,0.3,0,0.4L13.4,57C13.3,57,13.2,57,13,57z M11.6,52.9l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0 l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C11.3,52.9,11.4,52.9,11.6,52.9z M16.1,51.1c0.6,0.6,0.8,1.4,0.7,2.2c0,0,0,0-0.1,0l-0.9-0.9 c0.1-0.3,0-0.5-0.2-0.7s-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1C14.7,50.3,15.5,50.5,16.1,51.1z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: -2.5,
    y1: 39,
    x2: 6.5,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: -4,
    y1: 71.4,
    x2: 5,
    y2: 62.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.6,157.2c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3s-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1 c-0.1,0.3,0,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7 l0.9-0.9C10.1,157.4,10.4,157.4,10.6,157.2z M8,157.8l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9 c0,0.1,0,0.3,0,0.4l-0.9,0.9C8.3,157.7,8.1,157.7,8,157.8z M5.2,154.6l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1C5.3,154.8,5.3,154.7,5.2,154.6z M10.3,149.9l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0 l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C10,150,10.1,150,10.3,149.9z M13,152.7c0,0.1,0,0.3,0,0.4l-0.9,0.9c-0.1,0-0.3,0-0.4,0 l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L13,152.7z M9.9,155.9L8.9,155c0-0.1,0-0.3,0-0.4l0.9-0.9 c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4l-0.9,0.9C10.1,155.9,10,155.9,9.9,155.9z M8.4,151.8l0.9,1c0,0.1,0,0.2,0,0.4 l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C8.1,151.8,8.3,151.8,8.4,151.8z M13,150c0.6,0.6,0.8,1.4,0.7,2.2 c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1C11.6,149.2,12.4,149.4,13,150z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: -5.6,
    y1: 137.9,
    x2: 3.3,
    y2: 146.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: -7.1,
    y1: 170.3,
    x2: 1.8,
    y2: 161.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12.8,108.3c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3s-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1 c-0.1,0.3,0,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7 l0.9-0.9C12.3,108.6,12.6,108.5,12.8,108.3z M10.2,108.9L9.3,108c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9 c0,0.1,0,0.3,0,0.4l-0.9,0.9C10.5,108.9,10.3,108.9,10.2,108.9z M7.4,105.7l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4 l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1C7.5,106,7.5,105.9,7.4,105.7z M12.4,101.1l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0 l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C12.2,101.1,12.3,101.1,12.4,101.1z M15.2,103.9c0,0.1,0,0.3,0,0.4l-0.9,0.9 c-0.1,0-0.3,0-0.4,0l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L15.2,103.9z M12,107.1l-0.9-0.9c0-0.1,0-0.3,0-0.4 l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4l-0.9,0.9C12.3,107,12.2,107,12,107.1z M10.6,102.9l0.9,1 c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C10.3,103,10.5,103,10.6,102.9z M15.1,101.1 c0.6,0.6,0.8,1.4,0.7,2.2c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1 C13.7,100.3,14.6,100.6,15.1,101.1z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: -5,
    y1: 121.4,
    x2: 4,
    y2: 112.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.9,131.7c0.2-0.2,0.3-0.5,0.2-0.7L37,130c0.2,0.1,0.5,0,0.7-0.2s0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3s-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1 c-0.1,0.3,0,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7 l0.9-0.9C35.4,131.9,35.7,131.8,35.9,131.7z M33.3,132.3l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9 c0,0.1,0,0.3,0,0.4l-0.9,0.9C33.6,132.2,33.4,132.2,33.3,132.3z M30.5,129.1l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4 l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1C30.6,129.3,30.6,129.2,30.5,129.1z M35.5,124.4l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C35.3,124.4,35.4,124.4,35.5,124.4z M38.3,127.2c0,0.1,0,0.3,0,0.4 l-0.9,0.9c-0.1,0-0.3,0-0.4,0l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L38.3,127.2z M35.2,130.4l-0.9-0.9 c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4l-0.9,0.9C35.4,130.4,35.3,130.4,35.2,130.4z  M33.7,126.3l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9 C33.4,126.3,33.6,126.3,33.7,126.3z M38.3,124.5c0.6,0.6,0.8,1.4,0.7,2.2c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7 c-0.2-0.2-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1C36.9,123.7,37.7,123.9,38.3,124.5z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 19.7,
    y1: 112.4,
    x2: 28.6,
    y2: 121.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: -5,
    y1: 87.4,
    x2: 3.9,
    y2: 96.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 18.2,
    y1: 144.7,
    x2: 27.1,
    y2: 135.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.1,82.8c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2s0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3c-0.8-0.8-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7L35.9,76c-0.2-0.1-0.5,0-0.7,0.2s-0.3,0.5-0.2,0.7L34,77.8c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1 c-0.1,0.3,0,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7 l0.9-0.9C37.6,83.1,37.9,83,38.1,82.8z M35.5,83.4l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9 c0,0.1,0,0.3,0,0.4l-0.9,0.9C35.8,83.4,35.6,83.4,35.5,83.4z M32.7,80.2l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4 l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1C32.7,80.5,32.7,80.3,32.7,80.2z M37.7,75.6l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C37.5,75.6,37.6,75.6,37.7,75.6z M40.5,78.4c0,0.1,0,0.3,0,0.4l-0.9,0.9 c-0.1,0-0.3,0-0.4,0l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L40.5,78.4z M37.3,81.5l-0.9-0.9c0-0.1,0-0.3,0-0.4 l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4l-0.9,0.9C37.6,81.5,37.5,81.5,37.3,81.5z M35.9,77.4l0.9,1 c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C35.6,77.5,35.8,77.5,35.9,77.4z M40.4,75.6 c0.6,0.6,0.8,1.4,0.7,2.2c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1 C39,74.8,39.8,75,40.4,75.6z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 20.3,
    y1: 95.9,
    x2: 29.3,
    y2: 86.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M61.2,106.1c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3c-0.8-0.8-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7L59,99.3c-0.2-0.1-0.5,0-0.7,0.2s-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2s-0.3,0.5-0.2,0.7 l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1c-0.1,0.3,0,0.5,0.2,0.7 c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9 C60.7,106.4,61,106.3,61.2,106.1z M58.6,106.7l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4 l-0.9,0.9C58.9,106.7,58.7,106.7,58.6,106.7z M55.8,103.5l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1C55.9,103.8,55.9,103.7,55.8,103.5z M60.8,98.9l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0 l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C60.6,98.9,60.7,98.9,60.8,98.9z M63.6,101.7c0,0.1,0,0.3,0,0.4l-0.9,0.9c-0.1,0-0.3,0-0.4,0 l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L63.6,101.7z M60.5,104.9l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9 c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4l-0.9,0.9C60.7,104.8,60.6,104.8,60.5,104.9z M59,100.7l0.9,1c0,0.1,0,0.2,0,0.4 l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C58.7,100.8,58.9,100.8,59,100.7z M63.5,99c0.6,0.6,0.8,1.4,0.7,2.2 c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1C62.2,98.1,63,98.4,63.5,99z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 45,
    y1: 86.8,
    x2: 53.9,
    y2: 95.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 20.3,
    y1: 61.9,
    x2: 29.2,
    y2: 71
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 43.5,
    y1: 119.2,
    x2: 52.4,
    y2: 110.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.2,204.2c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3s-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7L6,197.4c-0.2-0.1-0.5,0-0.7,0.2c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1 c-0.1,0.3,0,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7 l0.9-0.9C7.7,204.5,8,204.4,8.2,204.2z M5.7,204.8l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9 c0,0.1,0,0.3,0,0.4L6,204.8C5.9,204.8,5.8,204.8,5.7,204.8z M2.9,201.6l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4 l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1C2.9,201.9,2.9,201.8,2.9,201.6z M7.9,197l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0 l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C7.6,197,7.8,197,7.9,197z M10.7,199.8c0,0.1,0,0.3,0,0.4l-0.9,0.9c-0.1,0-0.3,0-0.4,0 l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L10.7,199.8z M7.5,203L6.6,202c0-0.1,0-0.3,0-0.4l0.9-0.9 c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4L7.9,203C7.8,202.9,7.6,202.9,7.5,203z M6,198.8l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C5.8,198.9,5.9,198.9,6,198.8z M10.6,197c0.6,0.6,0.8,1.4,0.7,2.2 c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7s-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1C9.2,196.2,10,196.5,10.6,197z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: -8,
    y1: 184.9,
    x2: 1,
    y2: 194
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.7,179.5c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2s0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3s-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1 c-0.1,0.3,0,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7 l0.9-0.9C32.2,179.8,32.5,179.7,32.7,179.5z M30.2,180.1l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9 c0,0.1,0,0.3,0,0.4l-0.9,0.9C30.4,180.1,30.3,180.1,30.2,180.1z M27.4,176.9l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4 l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1C27.4,177.2,27.4,177,27.4,176.9z M32.4,172.3l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C32.1,172.3,32.3,172.3,32.4,172.3z M35.2,175.1c0,0.1,0,0.3,0,0.4 l-0.9,0.9c-0.1,0-0.3,0-0.4,0l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L35.2,175.1z M32,178.2l-0.9-0.9 c0-0.1,0-0.3,0-0.4L32,176c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4l-0.9,0.9C32.3,178.2,32.1,178.2,32,178.2z M30.5,174.1 l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C30.3,174.1,30.4,174.1,30.5,174.1z  M35.1,172.3c0.6,0.6,0.8,1.4,0.7,2.2c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.7-0.2l-0.9-1 c0,0,0,0,0-0.1C33.7,171.5,34.5,171.7,35.1,172.3z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 16.5,
    y1: 160.2,
    x2: 25.5,
    y2: 169.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 15,
    y1: 192.6,
    x2: 24,
    y2: 183.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58,154c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2s0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3c-0.8-0.8-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2s-0.3,0.5-0.2,0.7L54,149c-0.2-0.1-0.5,0-0.7,0.2s-0.3,0.5-0.2,0.7 l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1c-0.1,0.3,0,0.5,0.2,0.7 c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9 C57.5,154.2,57.8,154.2,58,154z M55.5,154.6l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4 l-0.9,0.9C55.7,154.6,55.6,154.6,55.5,154.6z M52.7,151.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1C52.7,151.7,52.7,151.5,52.7,151.4z M57.7,146.7l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0 l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C57.4,146.8,57.6,146.8,57.7,146.7z M60.5,149.5c0,0.1,0,0.3,0,0.4l-0.9,0.9 c-0.1,0-0.3,0-0.4,0l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L60.5,149.5z M57.3,152.7l-0.9-0.9c0-0.1,0-0.3,0-0.4 l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9c0,0.1,0,0.3,0,0.4l-0.9,0.9C57.6,152.7,57.4,152.7,57.3,152.7z M55.8,148.6l0.9,1 c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C55.6,148.6,55.7,148.6,55.8,148.6z M60.4,146.8 c0.6,0.6,0.8,1.4,0.7,2.2c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1 C59,146,59.8,146.2,60.4,146.8z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 41.8,
    y1: 134.7,
    x2: 50.8,
    y2: 143.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 40.3,
    y1: 167.1,
    x2: 49.3,
    y2: 158
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M83.3,128.5c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9c0.2,0.1,0.5,0,0.7-0.2c0.2-0.2,0.3-0.5,0.2-0.7l0.9-0.9 c0.2,0.1,0.5,0,0.7-0.2c0.3-0.3,0.3-0.7,0.1-1c0.2-1.1-0.1-2.2-0.8-3c-0.8-0.8-1.9-1.1-3-0.9c-0.3-0.2-0.7-0.2-1,0.1 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.3,0.5-0.2,0.7l-0.9,0.9c-0.2-0.1-0.5,0-0.7,0.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.7,0.2l0.9,1 c-0.1,0.3,0,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.7,0.2l0.9,0.9c-0.1,0.3,0,0.5,0.2,0.7c0.3,0.3,0.8,0.3,1.1,0c0.2-0.2,0.3-0.5,0.2-0.7 l0.9-0.9C82.8,128.7,83.1,128.7,83.3,128.5z M80.7,129.1l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,0.9 c0,0.1,0,0.3,0,0.4l-0.9,0.9C81,129,80.9,129,80.7,129.1z M78,125.9l0.9-0.9c0.1,0,0.3,0,0.4,0l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1C78,126.1,78,126,78,125.9z M83,121.2l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1c-0.1,0-0.2,0-0.4,0l-0.9-1 c0-0.1,0-0.3,0-0.4l0.9-0.9C82.7,121.2,82.8,121.2,83,121.2z M85.8,124c0,0.1,0,0.3,0,0.4l-0.9,0.9c-0.1,0-0.3,0-0.4,0l-0.9-0.9 c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0L85.8,124z M82.6,127.2l-0.9-0.9c0-0.1,0-0.3,0-0.4l0.9-0.9c0.1,0,0.3,0,0.4,0 l0.9,0.9c0,0.1,0,0.3,0,0.4l-0.9,0.9C82.8,127.2,82.7,127.2,82.6,127.2z M81.1,123.1l0.9,1c0,0.1,0,0.2,0,0.4l-0.9,1 c-0.1,0-0.2,0-0.4,0l-0.9-1c0-0.1,0-0.3,0-0.4l0.9-0.9C80.9,123.1,81,123.1,81.1,123.1z M85.7,121.3c0.6,0.6,0.8,1.4,0.7,2.2 c0,0,0,0-0.1,0l-0.9-0.9c0.1-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.7-0.2l-0.9-1c0,0,0,0,0-0.1C84.3,120.5,85.1,120.7,85.7,121.3 z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 67.1,
    y1: 109.2,
    x2: 76,
    y2: 118.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 65.6,
    y1: 141.6,
    x2: 74.6,
    y2: 132.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.ea962963d0f7f08d1048ea7a0fbcbf32.svg";
export { ForwardRef as ReactComponent };